export const queryParameters = {
  languageCode: 'languageCode',
};
